<template>
  <session class="page-header" :class="{ block: scrollTop > 10 }">
    <div class="container header-container">
      <div class="logo"><span>Stream Prompt</span></div>
      <div class="navs">
        <span @click="smoothScrollTo('#aboutus')">About Us</span>
        <span @click="smoothScrollTo('#intro')">Function Introduction</span>
        <!-- <span @click="smoothScrollTo('#download')">Download APP</span> -->
      </div>
    </div>
  </session>
  <session class="page-container">
    <slot></slot>
  </session>
  <session class="page-footer">
    <div class="container">
      <div class="footer-container">
        <!-- <div class="footer-item"><a href="/protocol/private" _target="blank">Privacy</a></div> -->
        <!-- <div class="footer-item"><span>杭州有前文化传媒有限公司 | 浙江省杭州市钱塘区 下沙街道泰美国际大厦2幢1906室一3 | 联系我们 buzuoiihua@126.com</span></div> -->
        <div class="footer-item"><span>Copyright © 2025 Stream Prompt ｜  Stream Prompt@126.com </span></div>
      </div>
    </div>
  </session>
</template>

<script setup>
  import { onMounted, ref } from 'vue';

  const scrollTop = ref(0)
  onMounted(() => {
    window.addEventListener('scroll', function () {
      scrollTop.value = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    })
  })

  const smoothScrollTo = (target) => {  
    const targetPosition = document.querySelector(target).getBoundingClientRect().top + window.pageYOffset;  
    window.scrollTo({  
      top: targetPosition,  
      behavior: "smooth"  
    });  
  } 
</script>

<style scoped lang="less">
@import "index.less";
</style>
